import React from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import AuthLayout from './layout'
import SignIn from '../../components/form/auth/signin'
// import SocialMedia from '../../components/login-3/social-media'
import {useTranslation} from 'react-i18next';
import {useAppSelector} from "../../redux/store";
import styled from "styled-components";

export const AuthInfoText = styled.span`
  color: var(--it-text-grey);

  /* Body */
  font-family: "Basis Grotesque Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  letter-spacing: 0.42px;

  //TODO: check the media point transition
  @media all and (max-width: 1000px) {
    font-size: 12px;
  }
`

const Index = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const {settings} = useAppSelector()
    const {isLoggedIn} = useSelector(
        state => ({
            isLoggedIn: state.user.isLoggedIn
        }),
        shallowEqual
    )
    if(isLoggedIn){
        setTimeout(()=>history.push("/dashboard"), 1);
    }

    //TODO: remove unused imgUrl?
    return (
        <AuthLayout imgUrl="/pages/auth/illustration.svg"
                    title={t('auth.signin.title', {projectName: settings.project_name})}
                    description={t('auth.signin.description')}>
            <SignIn />
            <div className="mt-4 mb-2">
                {/*<SocialMedia />*/}
            </div>
            <div className="flex flex-row justify-center w-full mb-2">
                <AuthInfoText className="mr-1">{t('auth.newuser')}</AuthInfoText>
                <AuthInfoText>
                  <Link className="link" to="/auth/signup">
                    {t('auth.create_account')}
                  </Link>
                </AuthInfoText>
            </div>
            <div className="flex justify-center w-full">
              <AuthInfoText>
                <Link className="link" to="/auth/forgot-password">
                  {t('auth.forgotpassword')}
                </Link>
              </AuthInfoText>
            </div>
        </AuthLayout>
    )
}

export default Index
